// extracted by mini-css-extract-plugin
module.exports = {"cls1":"List-module--cls1--1LVle","cls2":"List-module--cls2--I81eN List-module--cls1--1LVle"};